var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCookpot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_3572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1822 11.9464C0.644706 11.6707 0.432461 11.0115 0.708132 10.4741C0.983804 9.93656 1.643 9.72432 2.18049 9.99999L4.9611 11.4261C5.49859 11.7018 5.71083 12.361 5.43516 12.8985C5.15949 13.436 4.50029 13.6482 3.9628 13.3726L1.1822 11.9464Z",
    fill: "#C15C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8178 11.9464C24.3553 11.6707 24.5675 11.0115 24.2919 10.4741C24.0162 9.93656 23.357 9.72432 22.8195 9.99999L20.0389 11.4261C19.5014 11.7018 19.2892 12.361 19.5648 12.8985C19.8405 13.436 20.4997 13.6482 21.0372 13.3726L23.8178 11.9464Z",
    fill: "#C15C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50977 10.311C3.50977 9.20647 4.4052 8.31104 5.50977 8.31104H19.4473C20.5518 8.31104 21.4473 9.20647 21.4473 10.311V18.936C21.4473 20.5929 20.1041 21.936 18.4473 21.936H6.50977C4.85291 21.936 3.50977 20.5929 3.50977 18.936V10.311Z",
    fill: "#FFA552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69727 3.04541C8.69727 2.62257 9.04005 2.27979 9.46289 2.27979C9.88573 2.27979 10.2285 2.62257 10.2285 3.04541V6.13916C10.2285 6.562 9.88573 6.90479 9.46289 6.90479C9.04005 6.90479 8.69727 6.562 8.69727 6.13916V3.04541Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7129 3.04541C11.7129 2.62257 12.0557 2.27979 12.4785 2.27979C12.9014 2.27979 13.2441 2.62257 13.2441 3.04541V6.13916C13.2441 6.562 12.9014 6.90479 12.4785 6.90479C12.0557 6.90479 11.7129 6.562 11.7129 6.13916V3.04541Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.791 3.04541C14.791 2.62257 15.1338 2.27979 15.5566 2.27979C15.9795 2.27979 16.3223 2.62257 16.3223 3.04541V6.13916C16.3223 6.562 15.9795 6.90479 15.5566 6.90479C15.1338 6.90479 14.791 6.562 14.791 6.13916V3.04541Z",
    fill: "#FFD494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_3572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.10791)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookpot);
export default __webpack_public_path__ + "static/media/Cookpot.738444f6cbc450f78ea5318897dbd66a.svg";
export { ForwardRef as ReactComponent };